@use '../../styles/variables.scss';

.indeterminate-checkbox {
  $self: &;

  &__label {
    display: block;
    position: relative;
    margin-bottom: 0;
    font-size: variables.$text-size--normal;
    line-height: variables.$line-height--normal;
    font-weight: variables.$font-weight--normal;
    min-height: 24px;
    width: 24px;
    > [role='checkbox'] {
      height: 24px;
    }
  }

  &__input {
    opacity: 0;
    height: 0;
    width: 0;
    position: absolute;
    display: block;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  &__input:checked ~ &__checkmark &__checkmark-icon,
  &__input--indeterminate ~ &__checkmark &__checkmark-icon {
    opacity: 1;
    transform: scale(1);
  }

  &__checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    border: 1px solid variables.$in--black-50;
    border-radius: 2px;
    background-color: variables.$color--white;
    transition-duration: variables.$transition--poppy;
    cursor: pointer;

    &--disabled {
      border-color: #bfbfbf;
      background-color: #f2f2f2;
      cursor: default;
    }
  }

  &__checkmark-icon {
    position: absolute;
    transition-duration: variables.$transition--poppy;
    left: 3px;
    top: 3px;
    width: 16px;
    height: 16px;
    border-width: 0 3px 3px 0;
    transform: scale(0.01);
    opacity: 0.3;
    line-height: 1;

    path {
      fill: variables.$in--blue-150;
    }
  }

  //   Om man trenger offset på indeterminate ikon
  //   &__input--indeterminate ~ &__checkmark &__checkmark-icon svg {
  //     margin-left: 5px;
  //   }

  &__input:focus {
    ~ #{$self}__checkmark {
      outline: 0;
      box-shadow:
        0 0 0 2px grey,
        0 0 0 5px #fff771;
    }
  }

  &__label:hover &__input:not(:checked) {
    ~ #{$self}__checkmark #{$self}__checkmark-icon {
      opacity: 0.5;
      transform: scale(1);
    }
  }

  &__label:hover &__input:disabled {
    ~ #{$self}__checkmark {
      box-shadow: none;
    }
  }

  &__label:hover &__input:disabled:not(:checked) {
    ~ #{$self}__checkmark #{$self}__checkmark-icon {
      display: none;
    }
  }

  &__input {
    &--disabled {
      cursor: auto;
      color: variables.$in--black-25;

      #{$self}__checkmark {
        border: 1px solid variables.$in--black-25;
      }

      #{$self}__checkmark-icon {
        path {
          fill: variables.$in--black-25;
        }
      }
    }
  }
}
